<template>
	<div class="docMain">
		<div class="title"><span style="color:#c30d23;cursor:pointer;" @click="goback(1)">更新日志</span>  /  {{term_name==''?'新增更新':term_name}}</div>
		<div class="content">
			
			<div class="title_warp">
				<input type="text"  style="display: none"/>
				<input type="password" autocomplete="off" style="display: none"/>
				<Input v-model="title" class="bordiv" size="large" placeholder="请输入标题" :disabled="disabled" />
			</div>
			<div style="width:70%;">
				<div id="editorElem" style="text-align:left"></div>
			</div>	
			<div class="add_notice" @click="save_log">确认添加</div>
		</div>
	</div>
</template>
<script>
import E from 'wangeditor'
// import editor from './UE.vue'/
	export default{
		// components: { editor},
		data(){
			return{
				term_name:'',
				type:0,
				notice:"",   //通知
				recipient:[],   //接收人
				title:"",   //标题
				editorContent:"",
				editable:true,
				titles:'新增更新',
				disabled:false,
				content:'',
			}
		},
		mounted() {
			let _this = this;
			let college='';
        	var editor = new E('#editorElem')
        	editor.customConfig.onchange = (html) => {
          		this.editorContent = html
        	}

        	// editor.$textElem.attr('contenteditable', _this.editable)
        	editor.customConfig.uploadImgHeaders = {
			    'Authorization':  localStorage.getItem('Authorization')
			}
			// console.log(localStorage.getItem('Authorization'))
        	editor.customConfig.pasteFilterStyle = false   // 关闭粘贴样式的过滤
        	editor.customConfig.pasteIgnoreImg = true		// 忽略粘贴内容中的图片
        	editor.customConfig.uploadImgServer = strUrl + 'uploadfile'		// 配置服务器端地址 
        	editor.customConfig.uploadFileName = "file"
        	editor.customConfig.zIndex = 0
        	editor.customConfig.menus = [          // 菜单配置
        		'head',  // 标题
			    'bold',  // 粗体
			    'fontSize',  // 字号
			    'fontName',  // 字体
			    'italic',  // 斜体
			    'underline',  // 下划线
			    'strikeThrough',  // 删除线
			    // 'link',  // 插入链接
			    // 'list',  // 列表
			    'justify',  // 对齐方式
			    //'emoticon',  // 表情
			    'image',  // 插入图片
			    //'video',  // 插入视频
			    //'code',  // 插入代码
			    'undo',  // 撤销
			    'redo'  // 重复
	        ]	
        	
	        editor.customConfig.uploadImgHooks = {
	            before: function (xhr, editor, files) {
	            },
	            success: function (xhr, editor, result) {
	            	if(result.code == 115){
	            		_this.$Message.error(result.message)
	            		localStorage.removeItem('Authorization')
	            		_this.$router.replace('/login')
	            	}
	                  // 图片上传并返回结果，图片插入成功之后触发
	                  // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
	                // this.imgUrl = Object.values(result.data).toString()
	            },
	            fail: function (xhr, editor, result) {
	                  // 图片上传并返回结果，但图片插入错误时触发
	                  // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
	            },
	            error: function (xhr, editor) {
	                  // 图片上传出错时触发
	                  // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
	            },
	            timeout: function (xhr, editor) {
	                  // 图片上传超时时触发
	                  // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
	            },

	              // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
	              // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
	            customInsert: function (insertImg, result, editor) {
	            	// console.log('---insertImg---'+insertImg)
	            	// console.log('---editor---'+editor)
	            	// console.log('---result---'+result)
	                  // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
	                  // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
        				// console.log(editor.txt.html())
	                  // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
	                //let url = Object.values(result.data.path_sign)      // result.data就是服务器返回的图片名字和链接
	                let url = result.data.path_sign
	                insertImg(url)
	                  // result 必须是一个 JSON 格式字符串！！！否则报错
	            }
	        }

        	editor.create()
        	if(_this.$route.query.notice_id){
				_this.titles = "编辑"
				_this.$axios.post('getnoticedetail',{notice_id:_this.$route.query.notice_id}).then( res =>{
					if(res.data.code == 200){
						_this.title = res.data.data.title
						/*for(var i = 0; i< res.data.data.receiver_men.length; i++){
			        		_this.recipient.push(parseInt(res.data.data.receiver_men[i]))
			        	}
			        	_this.notice = res.data.data.type*/
			        	_this.content = res.data.data.content
			        	editor.txt.html(res.data.data.content)
			        	this.editorContent = res.data.data.content
			        	// this.editorContent=editor.txt.html().replace(/<p><br><p>/gi,"")
					}
					else{
						_this.$Message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			}
        	// if(_this.$route.query.notice_id){
        		
        	// 	console.log(_this.content)
        	// }
        	
        	editor.$textElem.attr('contenteditable', _this.editable);  
        	// editor.disable();
        	$('.w-e-text-container').attr('style','min-height:300px;border:1px solid #ccc; border-top:none; z-index:0;');
        	$('.w-e-text').attr('style','min-height:300px;width: 100%;');
      },
		methods:{
			save_import_notice(){
				let _this = this;
				_this.type = _this.type == 0 ? 1 : 0
			},
			goback(){
				let _this = this;
				_this.$router.go(-1)
			},
			save_log(){
				let _this = this;
				if(_this.title == ""){
					_this.$Message.error("标题不可为空")
				}
				else if(_this.editorContent == "" || _this.editorContent == "<p><br></p>"){
					_this.$Message.error("内容不可为空")
				}
				else{
					_this.editorContent = _this.editorContent.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,function(match,capture){
						// var newStr= 
						var newStr = match.replace(/src\s*?=\s*?([‘"])[\s\S]*?\1/ig,'src="'+ capture.slice(0,capture.indexOf('?')) + '"') 
					　　//capture,返回每个匹配的字符串
					　　return newStr;
					});
					/*_this.editorContent= _this.editorContent.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,function(match,capture){
					　　//capture,返回每个匹配的字符串
					　　var newStr='<img src="'+capture.slice(0,capture.indexOf('?'))+'" alt="" />';
					　　return newStr;
					});*/
					_this.$nextTick(()=>{
						if(_this.$route.query.notice_id){
							_this.$axios.post('addupdatelog',{
								notice_id:_this.$route.query.notice_id,
								title:_this.title,
								content:_this.editorContent
							}).then( res =>{
								if(res.data.code == 200){
									_this.$Message.success('通知已发出')
									_this.goback()
								}
								else{
									_this.$Message.error(res.data.message)
								}
							}).catch( error =>{
								console.log(error)
							})
						}
						else{
							_this.$axios.post('addupdatelog',{
								title:_this.title,
								content:_this.editorContent
							}).then( res =>{
								if(res.data.code == 200){
									_this.$Message.success('新增成功')
									_this.goback()
								}
								else{
									_this.$Message.error(res.data.message)
								}
							}).catch( error =>{
								console.log(error)
							})
						}
						
					})
					
				}
				
				// console.log(this.editorContent)
			},
		},
		created(){
			let _this = this;
// _this.OSnow();
			
		},		
		watch:{
			editorContent(){
				
			}
		}
	};
</script>
<style scoped>
	.title{
	    line-height: 68px;
	    color: #303030;
	    font-size: 18px;
	}
	.content{width: 100%;min-height: 686px;border: 1px solid #E6E6E6;background: #fff;padding:11px 24px;}
	.title_warp{margin: 15px 0;width: 540px;}
	.add_notice{padding:8px 15px;background: #c30d23;color: #fff;border-radius: 4px;cursor: pointer;display: inline-block;margin-top:20px;}
	.lookteas:hover{color: #c30d23;text-decoration: underline;cursor: pointer;}
	#editorElem{height: auto;}
	.import_notice{line-height: 36px;margin-left: 15px;padding-left: 25px;background: url(../../../static/imgs/duihao_n.png) left center no-repeat;background-size: 16px;cursor: pointer;}
	.active{background-image: url(../../../static/imgs/duihao_p.png);}
</style>


// WEBPACK FOOTER //
// src/components/peizhi/newLog.vue